import React,{useState, useEffect, useRef}  from 'react';
import {useHistory,useParams} from 'react-router-dom'
import {Segment,Header,Icon,Container,  Button}  from 'semantic-ui-react'
import MyTabulator,{dateFormatter, autoNumFormatter} from '@wollo-lib/wollo-tabulator'
import ModalEditKunde from '../UserList/ModalEditUser'


const Laender={ 'CH':'Schweiz','D':'Deutschland','A':'Österreich'}

const ShowKunde=({db})=>
{
    const usersDB=db.users
    const paketeDB=db.pakete
    const {UID,data}=useParams()
    const [user,setUser]=useState({})
    const [pakete,setPakete]=useState([])

    const [revision,setRevision]=useState(0)
    const history = useHistory()

    const [modalOpen,setModalOpen]=useState(false)

    useEffect(()=>{

        const getUser= async()=>
        {
            const myUser= await usersDB.where({UID:UID}).first()
            if(myUser)
            {

                myUser.LandLang=Laender[myUser.Land] ? Laender[myUser.Land] :myUser.Land
                setUser(myUser)
            }
            else
            {
                history.push('/')
            }



        }
        if(usersDB)
            getUser()
    },[UID,usersDB,revision,data])

    useEffect(()=>{

        const getPakete= async()=>
        {
            const myPakete= await paketeDB.where({Kunde:UID}).sortBy('Datum')
            setPakete(myPakete)
        }
        if(paketeDB && user.UID)
            getPakete()
    },[ UID, user, paketeDB])


    const openEdit=()=>
    {
        setModalOpen(true)
    }



    function cellClick (cell) 
    {
        if(cell.getField()==='UID')
        {
            history.push(`/show/paket/${cell.getValue()}`)
        }
    }



    const columns=[
   
        {formatter:autoNumFormatter, width:50, frozen:true}, //incrementing row number
        {formatter:(cell, formatterParams)=>('<i class="icon edit"></i>'), field:'UID', width:50, hozAlign:"center"}, // edit 
        { title: 'Dienst', field: 'Dienst', width: 120,  headerFilter:"input"},
        { title: 'Datum', field: 'Datum', width: 120, formatter:dateFormatter},
        { title: 'Paketnummer', field: 'Paketnummer', width: 300,  headerFilter:"input"},
        { title: 'Grösse/Art', field:'Size', width: 120, headerFilter:"input"}
        
    ]

    return (
    <>
        <Container>
            <Segment>
              <Header as ="h2">{user.Vorname} {user.Nachname}&nbsp;&nbsp;&nbsp;{<Button basic position='right' circular onClick={openEdit} icon='edit'/>}</Header>
                  <div>    
                    <p>{user.Strasse}<br/>
                    {user.PLZ} {user.Ort}<br/>
                    {user.LandLang}</p>
                    <p><Icon name="phone"/>{user.Festnetz}<br/>
                    <Icon name="mobile alternate"/>{user.mobil}<br/>
                    <Icon name="mail"/>{user.email}
                    </p>
                </div>

                <Header as="h4">Paketliste</Header>
                <MyTabulator
                    index='UID'
                    columns={columns}
                    headerFilterPlaceholder="Spalte filtern"
                    data={pakete}
                    onClick={cellClick}

        
                 />

            </Segment>
        </Container>
        <ModalEditKunde
          open={modalOpen}
          setOpen={setModalOpen}
          db={db}
          setRevision={setRevision}
          UID={UID}
        />
    </>
    )

}
export default ShowKunde
